module.exports = __webpack_public_path__ + "img/2.629c568e.png";